import { faUserTie as IconeParticipacaoAdvogado } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { Component } from 'react';
import MuiUtil from '@/util/MuiUtil';

class IconeAdvogado extends Component {
    static titlePadrao = (<Typography>Pedido de participação em sessão (preferência / sustentação oral)</Typography>);
    static corPadrao = 'black';
    static opacidadePadrao = '1';
    static tamanhoPadrao = '21px';
    removerTooltip = false;
    removerEstiloPadrao = false;

    static get sxPadrao() {
        return {
            color: IconeAdvogado.corPadrao,
            fill: IconeAdvogado.corPadrao,
            fillOpacity: IconeAdvogado.opacidadePadrao,
            width: IconeAdvogado.tamanhoPadrao,
            height: IconeAdvogado.tamanhoPadrao
        };
    }

    constructor(props) {
        super(props);

        let { removerEstiloPadrao, removerTooltip, title, ...propsIcone } = this.props;

        // Carrega as propriedades do tooltip
        this.removerTooltip = removerTooltip !== undefined ? removerTooltip : this.removerTooltip;
        this.title = title !== undefined ? title : IconeAdvogado.titlePadrao;

        // Carrega as propriedades do ícone
        this.removerEstiloPadrao = removerEstiloPadrao !== undefined ? removerEstiloPadrao : this.removerEstiloPadrao;

        if (this.removerEstiloPadrao) {
            this.propsIcone = propsIcone;
        } else {
            this.propsIcone = MuiUtil.mesclarSxStyle(propsIcone);
            this.adicionarSxPadrao();
        }
    }

    /**
     * @desc Adiciona as propriedades padrão sem sobrescrever as existentes.
     */
    adicionarSxPadrao() {
        if (!Object.prototype.hasOwnProperty.call(this.propsIcone, 'sx')) {
            this.propsIcone.sx = IconeAdvogado.sxPadrao;
        } else {
            this.propsIcone.sx = { ...IconeAdvogado.sxPadrao, ...this.propsIcone.sx };
        }
    }

    render() {
        if (this.removerTooltip) {
            return (
                <FontAwesomeIcon
                    icon={IconeParticipacaoAdvogado}
                    {...this.propsIcone}
                />
            );
        } else {
            return (
                <Tooltip title={this.title}>
                    <FontAwesomeIcon
                        icon={IconeParticipacaoAdvogado}
                        {...this.propsIcone}
                    />
                </Tooltip>
            );
        }
    }
}

IconeAdvogado.propTypes = {
    removerEstiloPadrao: PropTypes.bool,
    removerTooltip: PropTypes.bool,
    title: PropTypes.node
};

export default IconeAdvogado;
